module.exports = __webpack_public_path__ + "img/glass_green.30aed010.png";